import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import OrtivisAvatarPreview from "../ortivis/OrtivisAvatarPreview";

export default function PlayerList({ players }) {
	const listRef = useRef(null);
	const [isScrollable, setIsScrollable] = useState(false);
	const [scrollPosition, setScrollPosition] = useState(0);

	// Check if scroll is needed
	useEffect(() => {
		const checkScrollable = () => {
			if (listRef.current) {
				setIsScrollable(
					listRef.current.scrollWidth > listRef.current.clientWidth
				);
			}
		};
		checkScrollable();
		window.addEventListener("resize", checkScrollable);
		return () => window.removeEventListener("resize", checkScrollable);
	}, [players]);

	// Scroll to the end when a new player is added
	useEffect(() => {
		if (listRef.current) {
			listRef.current.scrollTo({
				left: listRef.current.scrollWidth,
				behavior: "smooth",
			});
		}
	}, [players]);

	// Track scroll position
	const handleScroll = () => {
		if (listRef.current) {
			setScrollPosition(listRef.current.scrollLeft);
		}
	};

	return (
		<div className="mt-4 w-full flex flex-col items-center relative">
			<h2 className="text-md font-semibold mb-3">Joueurs :</h2>

			{/* Scrollable Player List */}
			<div className="relative w-full">
				{/* Left Scroll Indicator */}
				{isScrollable && scrollPosition > 0 && (
					<div className="absolute left-0 top-1/2 -translate-y-1/2 bg-gradient-to-r from-white to-transparent w-12 h-full flex items-center justify-start pointer-events-none z-50">
						<span className="text-gray-600 text-xl">◀</span>
					</div>
				)}

				{/* Scrollable List */}
				<ul
					ref={listRef}
					onScroll={handleScroll}
					className="w-full h-[160px] flex items-center gap-4 overflow-x-auto scroll-smooth px-2 scrollbar-hide"
				>
					<AnimatePresence>
						{players.map((player, index) => (
							<motion.li
								key={player.pseudo}
								initial={{ opacity: 0, y: -10 }}
								animate={{ opacity: 1, y: 0 }}
								exit={{ opacity: 0, y: 10 }}
								transition={{ duration: 0.3 }}
								className="relative flex flex-col items-center gap-1"
							>
								{/* Avatar Wrapper */}
								<div
									className="relative h-20 w-10 flex items-center justify-center rounded-full shadow-md
										backdrop-blur-2xl bg-blue-200/30"
								>
									<OrtivisAvatarPreview avatar={player.avatar} />
								</div>

								{/* Player Name */}
								<span className="text-xs mt-2 font-medium text-gray-700">
									{player.pseudo}
								</span>
							</motion.li>
						))}
					</AnimatePresence>
				</ul>

				{/* Right Scroll Indicator */}
				{isScrollable &&
					listRef.current &&
					scrollPosition <
						listRef.current.scrollWidth - listRef.current.clientWidth && (
						<div className="absolute right-0 top-1/2 -translate-y-1/2 bg-gradient-to-l from-white to-transparent w-12 h-full flex items-center justify-center pointer-events-none z-50">
							<span className="text-gray-600 text-xl">▶</span>
						</div>
					)}
			</div>
		</div>
	);
}
